/**
 * A decoded MIDI message → the router's backend-agnostic `InputEvent`, for one binding.
 *
 * The binding is needed only for relative encoders: a CC is a position or a step depending on how it was learned, and that decoding is MIDI's own (OSC sends floats).
 *
 * InputEvent: `{ kind: 'abs', value: 0…1 }` · `{ kind: 'rel', value: signed steps }` · `{ kind: 'press', value: velocity 0…1 }` · `{ kind: 'release' }`, each with the message's `number`, which a range binding reads as its position.
 */
import { decodeRelative } from './relative'

export const toInputEvent = (msg, binding) => {
	const ev = decode(msg, binding)
	return ev && { ...ev, number: msg.number }
}

const decode = (msg, binding) => {
	switch (msg.type) {
		case 'note':
			return msg.on ? { kind: 'press', value: msg.value } : { kind: 'release', value: 0 }
		case 'pc':
			return { kind: 'press', value: 1 }
		case 'cc':
			if (binding?.mode === 'relative') return { kind: 'rel', value: decodeRelative(msg.raw, binding.encoding) }
			return { kind: 'abs', value: msg.value }
		case 'nrpn':
			if (msg.delta !== undefined) return { kind: 'rel', value: msg.delta }
			return { kind: 'abs', value: msg.value }
		case 'cc14':
		case 'pitchbend':
			return { kind: 'abs', value: msg.value }
		default:
			return null
	}
}
